import { useMemo } from "react";
import { SocialNetworksId, CoachSettings } from "@/interfaces";
import { useAppSettings } from "./useAppSettings";
import { AppSettingPermissionsSummaryParams } from "@/services/bedrock";

interface SocialNetworkAccess {
  name: string;
  id: SocialNetworksId;
  permission: CoachSettings;
}

const socialNetworks: SocialNetworkAccess[] = [
  {
    name: "Facebook",
    id: "FB",
    permission: CoachSettings.POST_IN_FB,
  },
  {
    name: "Instagram",
    id: "IG",
    permission: CoachSettings.POST_IN_IG,
  },
  {
    name: "Twitter",
    id: "TW",
    permission: CoachSettings.POST_IN_TW,
  },
  {
    name: "LinkedIn",
    id: "LI",
    permission: CoachSettings.POST_IN_LI,
  },
  {
    name: "Instagram Story",
    id: "IG_STORY",
    permission: CoachSettings.POST_IN_IG_STORY,
  },
  {
    name: "TikTok",
    id: "TT",
    permission: CoachSettings.POST_IN_TT,
  },
  {
    name: "Google",
    id: "GL",
    permission: CoachSettings.POST_IN_GL,
  },
  {
    name: "Zillow",
    id: "ZL",
    permission: CoachSettings.POST_IN_ZL,
  },
];

export const useSocialSettings = (playerIdOverride?: number) => {
  var params: AppSettingPermissionsSummaryParams | undefined = undefined;
  if (playerIdOverride) {
    params = { accountType: "player", accountId: playerIdOverride };
  }
  const { hasAppSetting } = useAppSettings(params);

  const allowedNetworks: SocialNetworkAccess[] = useMemo(() => {
    const networks: SocialNetworkAccess[] = [];
    socialNetworks.forEach(network => {
      const hasSetting = hasAppSetting(network.permission);
      if (hasSetting) {
        networks.push(network);
      }
    });
    return networks;
  }, [hasAppSetting]);

  const allowedNetworkIds: SocialNetworksId[] = useMemo(() => {
    return allowedNetworks.map(network => network.id);
  }, [allowedNetworks]);

  return { allowedNetworks, allowedNetworkIds };
};
